import BundleProductCard from 'components/ProductPage/PdpBundling/BundleWidget/BundleProductCard/BundleProductCard';

export default BundleProductCard;
